<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header">
        <el-row>
          <el-col :span="12">
            <h3>节日宝</h3>
          </el-col>
          <el-col :span="6" :offset="6" style="text-align: right">
            <el-button size="mini" type="danger" @click="movein">转入</el-button>
            <el-button size="mini" type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="moveout">转出</el-button>
          </el-col>
        </el-row>


      </div>
      <el-row>
        <el-col :span="4" class="capital">
          <h5>当前余额</h5>
          <p>{{ account.movableamount }}元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>已投资额</h5>
          <p>{{ useamount.toFixed(2) }}元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>当前资产</h5>
          <p>{{ account.amount }}元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>当月收益</h5>
          <p>{{ account.interestthis }}元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>上月收益</h5>
          <p>{{ account.interestlast }}元</p>
        </el-col>
        <el-col :span="4" class="capital">
          <h5>历史收益</h5>
          <p>{{ account.interestamount }}元</p>
        </el-col>
      </el-row>
      <el-switch
        v-model="account.isautoinout"
        :active-value= 1
        :inactive-value= 0
        @change="setauto"
        active-text="自动转入转出">
      </el-switch>
      <div class="hint">
        <h4>温馨提示:</h4>
<!--        <p>{{ account.explain1 }}</p>-->
        <p>{{ account.explain2 }}</p>
      </div>
      <el-table
        :data="Holidaytype"
        style="width: 100%">
        <el-table-column
          prop="orderid"
          align="center"
          label="编号">
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="period"
          align="center"
          label="投资周期">
        </el-table-column>
        <el-table-column
          align="center"
          label="利息">
          <template slot-scope="scope">
            <span>{{ Number(scope.row.interest)*100 }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="starttime"
          align="center"
          label="开始时间"
          width="150">
        </el-table-column>
        <el-table-column
          prop="endtime"
          align="center"
          label="结束时间"
          width="150">
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="createHoliday(scope.row)">新建</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-tabs stretch>
        <el-tab-pane label="当前投资">
          <el-table
            :data="currentData"
            style="width: 100%"
            size="small"
            stripe>
            <el-table-column
              prop="order"
              align="center"
              label="定期宝编号">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="投资金额">
            </el-table-column>
            <el-table-column
              prop="period"
              align="center"
              label="投资周期">
            </el-table-column>
            <el-table-column
              prop="starttime"
              align="center"
              label="开始时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="endtime"
              align="center"
              label="结束时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="estimateinterest"
              align="center"
              label="预估收益">
            </el-table-column>
            <el-table-column
              align="center"
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="closefund(scope.row)">结算</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="历史投资">
          <el-table
            :data="historyData"
            style="width: 100%"
            size="small"
            stripe>
            <el-table-column
              prop="order"
              align="center"
              label="定期宝编号">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="投资金额">
            </el-table-column>
            <el-table-column
              prop="period"
              align="center"
              label="投资周期">
            </el-table-column>
            <el-table-column
              prop="starttime"
              align="center"
              label="开始时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="endtime"
              align="center"
              label="结束时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="realinterest"
              align="center"
              label="实际收益">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="资金明细">
          <el-form :inline="true" size="mini">
            <el-form-item label="委托日期">
              <el-date-picker
                v-model="capitalDetails.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="getCapitalDetails">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="capitalDetails.data"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              label="资金">
            </el-table-column>
            <el-table-column
              prop="balance"
              align="center"
              label="余额">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              label="时间">
            </el-table-column>
          </el-table>
          <div class="changePage">
            <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" icon="el-icon-arrow-left" @click="prevCapital" size="mini">上一页</el-button>
            <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor);float: right" icon="el-icon-arrow-right" @click="nextCapital" size="mini">下一页</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: "HolidayFund",
    data(){
      return{
        account:{
          amount:'0.00',
          movableamount:'0.00',
          totalamount:'0.00',
          interestamount:'0.00',
          interestthis:'0.00',
          interestlast:'0.00',
          isautoinout:0,
          explain1:'',
          explain2:''
        },
        Holidaytype:[],
        currentData:[],
        historyData:[],
        capitalDetails:{
          date:[],
          data:[],
          page:1,
          num:20
        },
      }
    },
    computed: {
      useamount:function () {
        let that = this;
        return Number(that.account.amount)-Number(that.account.movableamount);
      }
    },
    methods:{
      getHolidayFund(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "holiday_fund",
              token: sessionStorage.getItem("token"),
              action: 'queryfund'
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              /*let resData = res.data;
              let account = resData.data.account;
              switch (account.isautoinout) {
                case 0:
                  account.isautoinout = false;
                  break;
                case 1:
                  account.isautoinout = true;
                  break;
              }
              */
              let resData = res.data;
              that.account = resData.data.account;
              that.Holidaytype = resData.data.Holidaytype;
              that.currentData = resData.data.details;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      getquerydetails(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "holiday_fund",
              token: sessionStorage.getItem("token"),
              action: 'querydetails',
              status: '2',
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.historyData = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      getCapitalDetails(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "holiday_fund",
              token: sessionStorage.getItem("token"),
              action: 'querylog',
              page: that.capitalDetails.page,
              num:that.capitalDetails.num,
              start: that.capitalDetails.date[0],
              end:that.capitalDetails.date[1]
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.capitalDetails.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      createHoliday(data){
        let that = this;
        this.$prompt('您是否确定存入'+data.name, '新建'+data.name, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\d+$/,
          inputErrorMessage: '金额不正确'
        }).then(({ value }) => {
          let that = this;
          let money = parseInt(value);
          if (money <= 0 || isNaN(money)){
            this.$message({
              type: 'warning',
              message: '请输入正确金额'
            });
            return false;
          }else{

            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "holiday_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'createaccount',
                  Holidaytypeid: data.tid,
                  amount:value
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: 'success',
                    onClose:function () {
                      that.mainMethod();
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          }

        }).catch(() => {
        });
      },
      setauto(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "holiday_fund",
              token: sessionStorage.getItem("token"),
              action: 'setauto',
              isautoinout: that.account.isautoinout,
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                type:'success',
                message: that.$t(res.data.msgId),
                onClose:function () {
                  that.mainMethod();
                }
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      mainMethod(){
        this.getHolidayFund();
        this.getquerydetails();
        this.getCapitalDetails();
      },
      prevCapital(){

      },
      nextCapital(){

      },
      moveout(){
        this.$prompt('请输入转出金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\d+$/,
          inputErrorMessage: '金额不正确'
        }).then(({ value }) => {
          let that = this;
          let money = parseInt(value);
          if (money <= 0 || isNaN(money)){
            this.$message({
              type: 'warning',
              message: '请输入正确金额'
            });
            return false;
          }else{

            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "holiday_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'moveout',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: 'success',
                    onClose:function () {
                      that.mainMethod();
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          }


        }).catch(() => {
        });
      },
      movein(){
        this.$prompt('请输入转入金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\d+$/,
          inputErrorMessage: '金额不正确'
        }).then(({ value }) => {
          let that = this;
          let money = parseInt(value);
          if (money <= 0 || isNaN(money)){
            this.$message({
              type: 'warning',
              message: '请输入正确金额'
            });
            return false;
          }else{

            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "holiday_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'movein',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: 'success',
                    onClose:function () {
                      that.mainMethod();
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          }

        }).catch(() => {
        });
      },
      closefund(data) {
        let that = this;
        this.$confirm('您的节日宝还没到期,提前结算您将损失所有的利息', '节日宝结算', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "holiday_fund",
                token: sessionStorage.getItem("token"),
                action: 'closefund',
                Holidaydetailid: data.id
              }
            })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                that.$message({
                  type: 'success',
                  message: that.$t(res.data.msgId),
                  onClose: function () {
                    that.mainMethod();
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        }).catch(() => {

        });
      },
    },
    mounted:function () {
      this.getHolidayFund();
      this.getquerydetails();
      this.getCapitalDetails();
    }
  }
</script>

<style scoped>
  .capital{
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .capital h5{
    color: #999;
    font-size: 14px;
    font-weight: 300;
  }
  .capital p{
    color: red;
    font-size: 14px;
    font-weight: bold;
  }
  .hint{
    margin-top: 20px;
    line-height: 1.5;
  }
  .hint h4{
    color: red;
  }
  .hint p{
    font-size: 14px;
  }
  .multiple_box{
    width: 19%;
    float: left;
    margin-right: 1.25%;
  }
  .multiple_box:last-child{
    margin-right: 0;
  }
  .multiple_box p {
    line-height: 1.5;
    font-weight: bold;
    font-size: 18px;
    color: #909399;
  }
  .multiple{
    background: white;
    border: 1px solid #666;
    border-radius: 4px;
    padding: 20px 0;
    text-align: center;
  }
  .active_multiple{
    background: #f56c6c;
    color: #fff!important;
    border: 1px solid #f56c6c!important;
  }
  .active_multiple p{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/HolidayFund.vue